import { render, staticRenderFns } from "./SearchProductsList.vue?vue&type=template&id=b331b4fe&"
import script from "./SearchProductsList.vue?vue&type=script&lang=js&"
export * from "./SearchProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports